/*eslint-disable*/
import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import styled from 'styled-components'
import { Frame, H1, P, Input, Button, Checkbox, ExportButton, RowWrapper, RoundButton, convertHex } from '../ui-kit/styled-templates'

import { useStorageListener } from '../../hooks/useStorage';
import useDictionary from '../../hooks/useDictionary'
import { device } from "../tools/displaySize";

let LoadingPopUp = (props) => {
    let visible = useStorageListener(state => state.loading_counter > 0)
    let { t } = useDictionary()
    return (
        <Wrapper visible={visible} background={`grey`} >
            {t('@loading_pop_up')}
        </Wrapper>
    );
}

const Wrapper = styled.div`
    transition: all .2s ease;
    position: fixed;
    left: 50%;
    top: 115px;
    transform: translate(-50%, ${props => props.visible ? `-50%` : `-35px`}) scale(1.2);
    z-index: 2;
    visibility: ${props => props.visible ? `visible` : `hidden`};
    opacity: ${props => props.visible ? .8 : 0};
    cursor: default;
    border: 2px solid var(--accent-color-secondary);
    background-color: var(--accent-color-secondary);
    color: var(--default-bg-color);
    font-weight: 500;
    border-radius: 1rem;
    height: 1rem;
    font-size: .8rem;
    padding: .2rem 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    
    &:after {
        content: '';
        display: none;
    };
    
    
    @media ${device.tablet} {
        height: .8rem;
        font-size: .5rem;
        overflow: hidden;
        top: 65px;
    }
    
`;

export default LoadingPopUp;
/*eslint-enable*/